export default __webpack_public_path__ + "2ad9fdd.mp3";